import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthServiceBase } from '../services/auth/auth.service.base';
import { environment } from '../environments/environment';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthServiceBase) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method === 'OPTIONS') {
      return next.handle(req);
    }

    const idpUrl = environment.authConfig.issuer;
    if (idpUrl && req.url.startsWith(idpUrl)) {
      return next.handle(req);
    }

    const apiBaseUrl = environment.MayaTestToolApiBaseUrl;
    const bffBaseUrl = environment.mayaViewer?.bffBaseUrl;
    const isAbsoluteUrl = /^https?:\/\//i.test(req.url);
    if (
      isAbsoluteUrl &&
      apiBaseUrl &&
      !req.url.startsWith(apiBaseUrl) &&
      !(bffBaseUrl && req.url.startsWith(bffBaseUrl))
    ) {
      return next.handle(req);
    }

    const token = this.authService.accessToken;
    const idToken = this.authService.idToken;
    const isBffRequest = Boolean(bffBaseUrl && req.url.startsWith(bffBaseUrl));

    if (isBffRequest && token && token.trim() !== '') {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(req);
    }

    if (token && idToken && token.trim() !== '' && idToken.trim() !== '') {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'X-ID-Token': idToken,
        },
      });
    }

    return next.handle(req);
  }
}